//
//
//
//

export default {
  props: {
    sign: {
      type: String,
      required: false,
      default: 'plus'
    }
  },
  computed: {
    plusOrMinus() {
      return this.sign === 'plus' ? 'plus' : 'minus'
    }
  }
}
